// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

// utils
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

const providerPortal = (state) => get(state, ['admin', 'providerPortal'], {})

export const providerPortalList$ = createSelector(
  providerPortal,
  ({ providerPortalList = [] }) => providerPortalList
)

export const providerPortalLoading$ = createSelector(
  providerPortal,
  ({ providerPortalLoading }) => providerPortalLoading
)

export const providerPortalListWithAll$ = createSelector(
  providerPortalList$,
  (providerPortalList = []) => addAllValue(providerPortalList, true, 'All')
)

export const providerPortalListDropdown$ = createSelector(
  providerPortalList$,
  (providerPortalList = []) =>
    providerPortalList.map((item, key) => ({
      ...item,
      key,
      title: item.name,
      value: item.uuid
    }))
)

export const providerPortalItem$ = createSelector(
  providerPortal,
  ({ providerPortalItem = {} }) => providerPortalItem
)

export const providerPortalModalClinicians$ = createSelector(
  providerPortal,
  ({ providerPortalModalClinicians = [] }) => providerPortalModalClinicians
)

export const providerPortalModalCliniciansWithAll$ = createSelector(
  providerPortalModalClinicians$,
  (providerPortalModalClinicians = []) =>
    addAllValueV5({ list: providerPortalModalClinicians })
)
